export default __webpack_public_path__ + "static/media/token_xdai.b1babff6.svg";